import React from 'react';

/**
 * Data-driven plan acknowledgment checkboxes.
 * Renders checkboxes for any plan that defines an `acknowledgments` array in planDetails.
 */
export const PlanAcknowledgments = ({
  acknowledgments = [],
  acceptedAcknowledgments = {},
  onAcknowledgmentChange,
  errors = {}
}) => (
  <>
    {acknowledgments.map((ack) => (
      <div key={ack.key} className="form-group checkbox-group flex flex-col mt-4">
        <label className="custom-checkbox checkbox-well ml-0">
          <input
            type="checkbox"
            id={`ack_${ack.key}`}
            checked={!!acceptedAcknowledgments[ack.key]}
            onChange={(e) => onAcknowledgmentChange(ack.key, e.target.checked)}
          />
          <span className="checkmark"></span>
          <span className="checkbox-label-text">{ack.label}</span>
        </label>
        {errors[`ack_${ack.key}`] && <p className="error mt-2">{errors[`ack_${ack.key}`]}</p>}
      </div>
    ))}
  </>
);

